import {ShowMessageBox} from '../../types/message-box'
import {NotyNotify, NotyRing} from '../../types/noty'
import {Util} from 'yougile-util'

/**
 * @description
 * Object “Notifier” provides various ways to notify user
 * (see available methods).
 * @descriptionRu
 * Объект "Notifier" предлагает различные пути для нотификации
 * пользователя (см. доступные методы).
 */
export class Notifier {
  private static showMessageBox: ShowMessageBox
  private static notify: NotyNotify
  private static ring: NotyRing

  public static init(
    showMessageBox: ShowMessageBox,
    notify: NotyNotify,
    ring: NotyRing
  ): void {
    Notifier.showMessageBox = showMessageBox
    Notifier.notify = notify
    Notifier.ring = ring
  }

  /**
   * @code
   * Notifier.error('');
   * @example
   * Notifier.error('Task was added successfully');
   * @description
   * Shows error notification
   * @descriptionRu
   * Показывает нотификацию ошибки.
   */
  public static error(message: string): void {
    Notifier.showMessageBox(message, 'danger')
  }

  /**
   * @code
   * Notifier.warn('');
   * @example
   * Notifier.warn('This task is readonly!');
   * @description
   * Shows warning notification
   * @descriptionRu
   * Показывает нотификацию предупреждения.
   */
  public static warn(message: string): void {
    Notifier.showMessageBox(message, 'warning')
  }

  /**
   * @code
   * Notifier.success('');
   * @example
   * Notifier.success('Task was added successfully');
   * @description
   * Shows success notification
   * @descriptionRu
   * Показывает нотификацию успешно выполненного действия.
   */
  public static success(message: string): void {
    Notifier.showMessageBox(message, 'success')
  }

  /**
   * @code
   * Notifier.show('', '');
   * @example
   * Notifier.show('New message', 'Hi, how’s it going?');
   * @description
   * Shows browser notification
   * @descriptionRu
   * Показывает браузерную нотификацию.
   */
  public static show(
    title: string,
    message: string,
    onClick: () => void = Util.noop
  ): void {
    Notifier.notify(title, undefined, message, onClick, false, false)
  }

  /**
   * @code
   * Notifier.playSound();
   * @example
   * // default sound as in chats
   * Notifier.playSound();
   *
   * // another sound (7 sounds available)
   * Notifier.playSound(2);
   * @description
   * Plays sound
   * @descriptionRu
   * Проигрывает звук. Доступны 7 вариантов звуков.
   */
  public static playSound(soundNumber?: number): void {
    soundNumber = Math.abs(+soundNumber || 0) || 5
    soundNumber = ((soundNumber - 1) % 7) + 1
    const sounds = [
      'chat1',
      'chat2',
      'chat3',
      'chat4',
      'chat5',
      'chat6',
      'long'
    ]
    Notifier.ring(sounds[soundNumber - 1])
  }
}
